<template>
  <div>
    <el-row class="title-bar title-h3 vertical-center-box">수집/판단정책 목록</el-row>
    <el-row class="title-bar verical-center-box" type="flex" justify="space-between">
      <div class="setting-addel">
        <el-button size="mini" @click="addRule"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="selectedRules.length === 0" @click="deleteRule"><i class="fas fa-minus"></i></el-button>
      </div>
      <w-search-field width="200px" @search="onSearch"></w-search-field>
    </el-row>
    <el-row>
      <el-table class="setting" :data="filteredData" ref="ruleTable" @cell-dblclick="modifyRule" @selection-change="onSelectionChange" row-class-name="c-dblclick" show-overflow-tooltip highlight-current-row>
        <el-table-column type="selection" width="30" :selectable="selectable"/>
        <el-table-column prop="ruleTmplName"/>
        <el-table-column width="40">
          <template slot-scope="scope">
            <i class="far fa-search-plus c-pointer" @click="showRuleDetail(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <w-add-rule-popup ref="addRulePopup" :rule-type="ruleType" @close="loadData"/>
    <w-modify-rule-popup ref="modifyRulePopup" :rule-type="ruleType" @close="loadData"/>
  </div>
</template>

<script>
import clone from 'lodash/clone';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import { ruleType } from '@/constants/rule';
import WSearchField from '@/components/form/SearchField';
import { isTrue } from '@/utils/boolean';
import msgUtil from '@/utils/message';
import RuleSettingAPI from '@/api/settings/common/rule-settings';
import RuleAPI from '@/api/settings/common/rule';
import WAddRulePopup from '../../popup/AddRulePopup';
import WModifyRulePopup from '../../popup/ModifyRulePopup';

export default {
  name: 'WRuleList',
  components: {
    WSearchField,
    WAddRulePopup,
    WModifyRulePopup,
  },
  data() {
    return {
      ruleType: ruleType.RSC,
      selectedRules: [],
      selectedRule: [],
      ruleTableData: [],
      searchKeyword: null,
    };
  },
  computed: {
    filteredData() {
      if (isEmpty(this.searchKeyword)) {
        return this.ruleTableData;
      }
      const keyword = this.searchKeyword.toLowerCase();
      return filter(this.ruleTableData, (item) => item.ruleTmplName.toLowerCase().indexOf(keyword) > -1);
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    /**
     * 정채 목록을 로드한다.
     */
    loadData() {
      RuleAPI.getRscEventRules().then((response) => {
        this.ruleTableData = response.data.data;
        this.$nextTick(() => {
          if (isEmpty(this.selectedRule)) {
            const selectedRow = this.ruleTableData[0];
            this.$refs.ruleTable.setCurrentRow(selectedRow);
            this.showRuleDetail(selectedRow);
          }
        });
      });
    },
    /**
     * 자원별 수집 판단 정책 설정을 조회한다.
     * @author Ju
     * @param  {[type]} row [description]
     */
    showRuleDetail(row) {
      this.selectedRule = row;
      this.$emit('click-rule', row);
    },
    /**
     * 정책 선택 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} selection [description]
     */
    onSelectionChange(selection) {
      this.selectedRules = selection;
    },
    /**
     * 검색 이벤트 핸들러
     * @author Ju
     * @param  {[type]} value [description]
     */
    onSearch(value) {
      this.searchKeyword = value;
    },
    /**
     * 정책을 추가한다.
     * @author Ju
     */
    addRule() {
      this.$refs.addRulePopup.open();
    },
    /**
     * 정책을 수정한다.
     * @author Ju
     * @param  {[type]} data [description]
     */
    modifyRule(data) {
      this.$refs.modifyRulePopup.open(clone(data));
    },
    /**
     * 선택한 정책을 삭제한다.
     * @return {[type]} [description]
     * @author jda
     */
    deleteRule() {
      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
        RuleSettingAPI.deleteCollectionJudgementRule(this.selectedRules)
          .then((response) => {
            if (response.data.success) {
              this.loadData();
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '정책', response.data.success));
          });
      }).catch(() => {});
    },
    /**
     * 정책 선택 여부 설정
     * 기본 정책은 삭제할 수 없기 때문에 선택 불가능.
     * @author Ju
     * @param  {[type]} row [description]
     */
    selectable(row) {
      return !isTrue(row.defaultFlag);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/CollectionJudgementRuleSettings/components/RuleList.vue